import { ApiPageviewMetaTagger, ApiProject } from "@incendium/api";
import { pageviewMetaService } from "Apis";
import { useParentChildSharedState } from "./useSharedState";


const fetchPageviewMetaTaggers = (locationId: number) => async (project: ApiProject) => {
  const res = await pageviewMetaService.pageviewMetaServiceListPageviewMetaTaggers({
    projectId: project.id as number,
    locationId,
  });
  return res.results || [];
};

export const usePageviewMetaTaggers = (locationId: number) => {
  const { childState, setChildState, refetch } = useParentChildSharedState<ApiPageviewMetaTagger[], ApiPageviewMetaTagger[]>(
    "pageviewMetaTaggers",
    [],
    [],
    locationId,
    fetchPageviewMetaTaggers(locationId),
    fetchPageviewMetaTaggers(locationId)
  );

  return {
    pageviewMetaTaggers: childState,
    setPageviewMetaTaggers: setChildState,
    refetchPageviewMetaTaggers: refetch,
  };
};
